const settoriReducer = (state, action) => {
  switch (action.type) {
    default:
      return state;
  }
};

export { settoriReducer as default };
